import React from "react";
import {PartyActivity} from "core/event/eventDomain";
import {EmailEventHistory} from "core/event/component/historyBlocks";
import {ACTIVITYTYPE, ACTIVITYTYPE_MAP} from "core/event/eventDomain";
import * as icons from "core/components/buttons/svgIcons";
import styled from "styled-components";
import {grey400} from "material-ui/styles/colors";
import moment from "moment";
import {Watermark} from "core/components/common/watermark";

const MDiv = styled.div`
    margin-left: 20px;
    display: flex;
    align-items: center;
`;

const DateSpan = styled.span`
    margin-left: 6px;
    font-size: 18px;
    color: ${grey400};
`;

const MainDiv = styled.div`
  position: relative;
`;


export const ActivityBlock = ({activity} : {activity: PartyActivity}) => {
  const Icon = icons[ACTIVITYTYPE_MAP[activity.activityType.value].icon];

  if (activity) {
    switch (activity.activityType.value) {
      case ACTIVITYTYPE.EMAIL:

        return (
          <MainDiv>
            {(!activity.activitySent) ? <Watermark text="Not sent yet" fontSize={70}/> : null}
            <MDiv><Icon/> { (activity.activitySent) ? <DateSpan>{moment(activity.activitySent).fromNow()}</DateSpan> : null} </MDiv>
            <EmailEventHistory eventHistory={activity}/>
          </MainDiv>
        );
    }
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/core/event/component/taskActivityBlocks.tsx